
export class HisTableConfigResults {
    columResults: any[];
    isReorderable: boolean;
    frozenCol: string;

    constructor( columResults: any[], isReorderable: boolean, frozenCol: string ) {
        this.columResults = columResults;
        this.isReorderable = isReorderable;
        this.frozenCol = frozenCol;
    }
}
